import { StoreColumns } from "../../ColumnsConfig/StoreColumns";
import Table from "../../Components/Table";
import React, { useState, useEffect } from "react";
import "./../../App.css";
import loaderGif from "../../Assests/loader.gif";
import ConfirmationModal from "../../Common/ConfirmationModal";
import StoreFormDialog from "../../Modals/StoreFormDialog";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  IconButton,
  InputBase,
  Paper,
  Chip,
  TextField,
} from "@mui/material";
import "react-notifications/lib/notifications.css";
import StoreService from "../../Services/Store";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";



const Store = () => {
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const [pageSize, setPageSize] = useState(10); // Track page size
  const [searchValue, setSearchValue] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [chipValue, setChipValue] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [initialData, setInitialData] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [massUpdateUnitLimit, setMassUpdateUnitLimit] = useState("");
  const [stateData, setStateData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortColumn] = useState("");
  const [order, setSortOrder] = useState("asc");
  const [recordDeleted, setRecordDeleted] = useState(false);
  const [deleteError, setDeleteError] = useState(false);
  const [createRecord, setCreateRecord] = useState(false);
  const [createRecordError, setCreateRecordError] = useState(false);
  const [updateRecord, setUpdateRecord] = useState(false);
  const [updateRecordError, setUpdateRecordError] = useState(false);
  const validSortFields = ["store_number", "name"];
  const [selectedTab, setSelectedTab] = useState(0);
  const [storeNumber, setStoreNumber] = useState('');

  const fetchStoreData = async (
    page = currentPage,
    size = pageSize,
    sortByField = sortBy,
    sortOrder = order,
    searchTerm = searchValue
  ) => {
    setIsLoading(true);
    try {
      const queryObj = {
        page,
        pageSize: size,
        sortBy: validSortFields.includes(sortByField) ? sortByField : "name",
        order: sortOrder,
        search: searchTerm,
      };

      // Add searchTerm to the query object only if it's not empty

      const response = await StoreService.fetchStore(
        queryObj.page,
        queryObj.pageSize,
        queryObj.sortBy,
        queryObj.order,
        queryObj.search
      );

      const { data, totalRecords, totalPages } = response;

      if (Array.isArray(data)) {
        setRows(data.map((row) => ({ ...row, id: row.store_id })));
        setTotalRecords(totalRecords);
        setTotalPages(totalPages);
      } else {
        throw new Error("Unexpected API response format.");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.ErrorMessage || "Failed to fetch Store data.";
      console.error("Failed to fetch Store data:", errorMessage);
      NotificationManager.error(errorMessage, "Error", 5000);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStoreData();
  }, [chipValue]);

  useEffect(() => {
    fetchStoreData();
  }, [currentPage, pageSize]);

  useEffect(() => {
    if (
      recordDeleted ||
      deleteError ||
      createRecord ||
      createRecordError ||
      updateRecord ||
      updateRecordError
    ) {
      const timer = setTimeout(() => {
        setRecordDeleted(false);
        setDeleteError(false);
        setCreateRecord(false);
        setCreateRecordError(false);
        setUpdateRecord(false);
        setUpdateRecordError(false);
      }, 5000); // Hide alert after 5 seconds
      return () => clearTimeout(timer); // Cleanup timer if component unmounts
    }
  }, [
    recordDeleted,
    deleteError,
    createRecord,
    createRecordError,
    updateRecord,
  ]);

  const handlePageChange = (page, size) => {
    setCurrentPage(page); // Update current page
    setPageSize(size); // Update page size
  };

  const handleSort = (field, order) => {
    setSortColumn(field);
    setSortOrder(order);
    fetchStoreData(1, pageSize, field, order);
  };

  const activeRecords = rows.map((row) => {
    const state = Array.isArray(stateData)
      ? stateData.find((data) => row.state_id === data.state_id)
      : null;
    return {
      ...row,
      state_name: state ? state.state_name : "Unknown", // Attach state name or default to 'Unknown'
    };
  });
  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  // const handleSearch = () => {
  //   if (searchValue.trim() !== "") {
  //     setChipValue(searchValue);
  //     console.log("searchValue", searchValue);
  //     fetchStoreData(1, pageSize, sortBy, order, searchValue);
  //   } else {
  //     setChipValue("");
  //     fetchStoreData(); // Fetch all records if search term is empty
  //   }
  // };

  // const handleChipDelete = () => {
  //   setChipValue("");
  //   setSearchValue("");
  //   fetchStoreData(); // Fetch all records when chip is deleted
  // };

  const handleDialogOpen = () => {
    setInitialData(null);
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const createStore = async (formData) => {
    try {
      setIsLoading(true);

      // Filter out empty values from formData
      const sanitizedData = Object.fromEntries(
        Object.entries(formData).filter(([_, value]) => value !== "")
      );
      console.log("sanitizedData", sanitizedData);

      // Make the POST request to create the store
      const response = await StoreService.createStore(sanitizedData);
      console.log("response------", response);
      // Check if the response is not OK
      if (!response || response.message !== "Store inserted successfully") {
        throw new Error("Failed to save data");
      }

      const newSTORE = response.data;
      console.log("newSTORE--------------------", newSTORE);

      setRows((prevRows) => {
        const UpdatedRows = [
          ...prevRows,
          { ...newSTORE, id: newSTORE.store_id },
        ];
        fetchStoreData(); // Refresh data if needed
        return UpdatedRows;
      });

      NotificationManager.success(
        "Store created successfully.",
        "Success",
        3000
      );
      setIsDialogOpen(false); // Close the modal after successful save
    } catch (error) {
      setCreateRecordError(true);
      console.error("Error saving data-----------:", error.message);

      if (error.message.includes("400")) {
        NotificationManager.warning(
          "Please check your inputs.",
          "Bad Request",
          5000
        );
      } else if (error.message.includes("404")) {
        NotificationManager.info("Resource not found.", "Not Found", 5000);
      } else if (error.message.includes("500")) {
        NotificationManager.error(
          "Server error. Please try again.",
          "Internal Server Error",
          5000
        );
      } else {
        NotificationManager.error(
          `Error: ${error.message}`,
          "Save Failed",
          5000
        );
      }
    } finally {
      setIsLoading(false);
    }
  };
  const editStore = async (formData) => {
    try {
      setIsLoading(true);
      console.log("Updating Store with ID:", formData.store_id);

      // Remove `store_id` from the payload data
      const data = {
        dc_id: formData.dc_id,
        facility_routing_status: formData.facility_routing_status,
        facility_type_id: formData.facility_type_id,
        name: formData.name,
        abbreviation: formData.abbreviation,
        // store_number: formData.store_number,
        address: formData.address,
        city: formData.city,
        state_id: formData.state_id,
        zip: formData.zip,
        unit_limit: formData.unit_limit,
        primary_contact_name: formData.primary_contact_name,
        primary_contact_email: formData.primary_contact_email,
        primary_contact_phone: formData.primary_contact_phone,
        primary_contact_fax: formData.primary_contact_fax,
        secondary_contact_name: formData.secondary_contact_name,
        secondary_contact_email: formData.secondary_contact_email,
        secondary_contact_phone: formData.secondary_contact_phone,
        secondary_contact_fax: formData.secondary_contact_fax,
        exceptions_allowed: formData.exceptions_allowed,
      };
      console.log("data======--------------------", data);
      const sanitizedData = Object.fromEntries(
        Object.entries(data).filter(([_, value]) => value !== "")
      );
      console.log("sanitizedData", sanitizedData);

      if (formData.store_id) {
        const response = await StoreService.updateStore(
          formData.store_id,
          sanitizedData
        ); // Exclude `store_id` from the data
        console.log("response.data----489", sanitizedData);

        const result = sanitizedData;
        console.log("Results 492------------------>", result);

        // Update rows after successful response
        const updatedRows = rows.map((row) => {
          console.log("row.id", row.id, "formData.store_id", formData.store_id); // Debugging

          return row.id === formData.store_id
            ? { ...row, ...result.data }
            : row;
        });
        console.log("Store ID:", formData.store_id); // Check ID matching

        console.log("Updated rows:", updatedRows);

        setRows(updatedRows);
        setIsDialogOpen(false);
        setUpdateRecord(true);
        fetchStoreData();
        NotificationManager.success(
          "Store updated successfully.",
          "Success",
          3000
        );
      }
    } catch (error) {
      console.log("error update-------", error);
      console.error("Error updating data:", error.message);
      if (error.message.includes("400")) {
        NotificationManager.warning(
          "Please check your inputs.",
          "Bad Request",
          5000
        );
      } else if (error.message.includes("404")) {
        NotificationManager.info("Resource not found.", "Not Found", 5000);
      } else if (error.message.includes("500")) {
        NotificationManager.error(
          "Server error. Please try again.",
          "Internal Server Error",
          5000
        );
      } else {
        NotificationManager.error(
          `Error: ${error.message}`,
          "Save Failed",
          5000
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async (formData) => {
    if (initialData) {
      // Call the edit function
      await editStore(formData);
      console.log("formData.dc-id", formData.dc_id);
      setCreateRecord(false);
    } else {
      // Call the create function
      await createStore(formData);
      setCreateRecord(true);
      setUpdateRecord(false);
    }
    setIsDialogOpen(false);
  };
  const handleEdit = (rowData) => {
    setInitialData(rowData); // Set the row data for editing
    setIsDialogOpen(true); // Open the dialog in edit mode
  };

  const inactivateStore = async (storeId) => {
    try {
      console.log(`Attempting to inactivate Store with ID: ${storeId}`);
      const response = await StoreService.deleteStore(storeId);
      console.log("response571", response);

      if (!response) {
        throw new Error("Failed to Inactive data");
      }

      const result = response.data;
      console.log("Inactivate result:", result);
      // return result;
      NotificationManager.success(
        "Store deleted successfully.",
        "Success",
        3000
      );
      setIsDialogOpen(false); // Close the modal after successful save
    } catch (error) {
      console.error("Error saving data:", error.message);
      if (error.message.includes("400")) {
        NotificationManager.warning(
          "Please check your inputs.",
          "Bad Request",
          5000
        );
      } else if (error.message.includes("404")) {
        NotificationManager.info("Resource not found.", "Not Found", 5000);
      } else if (error.message.includes("500")) {
        NotificationManager.error(
          "Server error. Please try again.",
          "Internal Server Error",
          5000
        );
      } else {
        NotificationManager.error(
          `Error: ${error.message}`,
          "Save Failed",
          5000
        );
      }
    }
  };

  const handleDelete = (rowData) => {
    console.log("rowData---------", rowData);
    setRowToDelete(rowData);
    setIsDeleteModalOpen(true); // Open delete confirmation modal
  };

  const handleConfirmDelete = async () => {
    if (!rowToDelete) return;

    try {
      await inactivateStore(rowToDelete.id);
      setRows(rows.filter((row) => row.id !== rowToDelete.id)); // Remove the row from local state
      setIsDeleteModalOpen(false); // Close the modal
      await fetchStoreData(); // Refresh the data after inactivation
    } catch (error) {
      alert("Failed to inactivate Store. Please try again.");
    } finally {
      setRowToDelete(null); // Reset the row to delete
    }
  };
  const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
  };

  const handleMassUpdateUnitLimit = (e) => {
    setMassUpdateUnitLimit(e.target.value);
  };

  // Add tab change handler
const handleTabChange = (event, newValue) => {
  setSelectedTab(newValue);
  setStoreNumber('');
};

// Update search handler
const handleSearch = () => {
  const trimmedSearchTerm = searchValue.trim(); 
  setChipValue(trimmedSearchTerm);
  fetchStoreData(1, pageSize, sortBy, order, trimmedSearchTerm); 
};

const handleChipDelete = async() => {
  setChipValue('');
  try{
    await fetchStoreData(1, pageSize, sortBy, order, '');

  }catch(error){
    console.error('Error fetching SCAC data:', error);
    //NotificationManager.error("Failed to fetch SCAC data.", "Error", 5000);
  }finally{
    setSearchValue('');
  }
};


  return (
    <div className="px-5 my-1">
      <div>
        <NotificationContainer />
      </div>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center">
          <Paper component="form" className="search-container" onSubmit={(e) => e.preventDefault()}>
            <InputBase
              className="search-input"
              placeholder="Search SCACs"
              inputProps={{ 'aria-label': 'search SCACs' }}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
            <IconButton type="button" aria-label="search" onClick={handleSearch}>
              <SearchIcon />
            </IconButton>
          </Paper>
          {chipValue && (
            <Chip
              label={chipValue}
              onDelete={handleChipDelete}
              deleteIcon={<CloseIcon />}
              className="chip-style"
            />
          )}
        </Box>
        
      </Box>

        <Button
          variant="contained"
          onClick={handleDialogOpen}
          className="add-new-btn"
        >
          Add New Store
        </Button>
      </Box>
      <Box position="relative" mt={2}>
        <Table
          rows={rows}
          columns={StoreColumns(handleEdit, handleDelete)}
          className="table-header"
          currentPage={currentPage}
          pageSize={pageSize}
          totalRecords={totalRecords}
          onPageChange={handlePageChange}
          totalPages={totalPages}
          getRowId={(row) => row.storeId}
          onSort={handleSort}
        />

        {/* Loading overlay inside the table */}
        {isLoading && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex"
            justifyContent="center"
            alignItems="center"
            bgcolor="rgba(255, 255, 255, 0.8)"
            zIndex={1}
          >
            <img src={loaderGif} alt="Loading..." width={50} height={50} />
          </Box>
        )}
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
        mb={2}
      >
        <TextField
          margin="dense"
          name="massUpdateUnitLimit"
          label="Mass Update Unit Limit"
          fullWidth
          variant="outlined"
          value={massUpdateUnitLimit}
          onChange={handleMassUpdateUnitLimit}
          sx={{ flexGrow: 1, mr: 2 }}
        />
        <Button variant="contained" sx={{ backgroundColor: "#3f506b" }}>
          Update
        </Button>
      </Box>

      <StoreFormDialog
        open={isDialogOpen}
        handleClose={handleDialogClose}
        handleSave={handleSave}
        initialData={initialData}
      />

      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        message="Are you sure you want to inactivate this Store?"
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
      />
    </div>
  );
};
export default Store;
